import * as React from 'react';
// @ts-ignore
import { markAccountCreationStart } from 'utils/accountCompletionTracker';
import CurrentUser from 'auth/CurrentUser';
import GTMScript from 'components/GTMScript';

import './styles/SetupView.scss';

type Props = {
  children?: React.ReactNode;
};

class SetupView extends React.Component<Props> {
  componentDidMount() {
    markAccountCreationStart(CurrentUser.getUser());
  }

  render() {
    return (
      <div className="SetupView">
        <GTMScript />
        {this.props.children}
      </div>
    );
  }
}

export default SetupView;
